'use client';

import Link from 'next/link';
import styles from './Error404.module.scss';
import { Button, Container, Group, Space } from '@mantine/core';
import { useDictionary } from '@/src/dictionaries/dictionary-provider';

export default function Error404() {
  const dictionary = useDictionary();
  return (
    <Container my="md" style={{ textAlign: 'center' }}>
      <Space h="lg" />
      <h1>{dictionary.error404.title}</h1>
      <h2>{dictionary.error404.subtitle}</h2>
      <Space h="lg" />
      <Space h="lg" />
      <Space h="lg" />
      <Group justify="center" gap="md" wrap="wrap">
        <Button component={Link} className={styles.button} href="/">
          {dictionary.error404.returnHomepage}
        </Button>
        <Button component={Link} className={styles.button} href="/articles">
          {dictionary.error404.returnArticles}
        </Button>
      </Group>
    </Container>
  );
}
